/**
 * 유형 테스트 완료글 일괄 연결 신호 (열려 있는 문항 화면이 보고 자기 연결을 바꾼다, 나중에 여는 섹션도 그릴 때 본다)
 * - PATTERN: 순서마다 완료글 (pattern[0] = 1번 보기·열·조건에 연결할 survey_ending_no 목록, null이면 그 순서는 그대로), pageNos가 있으면 그 섹션, moduleTypes 유형 문항만
 *   순위형은 항목 × 순위 표를 한 줄로 (cols = 순위 수, 나머지는 1)
 * history: 이 창을 연 뒤 넣은 신호를 넣은 순서대로 모두 (아직 안 연 섹션은 그릴 때 처음부터 차례로 적용, 마지막 것만 보면 앞서 넣은 다른 유형 값이 빠진다)
 * 저장값(jumpExampleCount)은 넣는 쪽에서 따로 한 번에 바꾼다 (아직 안 연 섹션도 저장에 들어가게)
 */
export const INIT = 'survey/create/logic/jumpExampleCountPattern/INIT'
export const PATTERN = 'survey/create/logic/jumpExampleCountPattern/PATTERN'

export type EndingPattern = (number[] | null)[]

export interface PatternEntry {
    pattern: EndingPattern;
    pageNos: number[] | null;
    moduleTypes: string[];
    cols: number;
}

interface State {
    pattern: EndingPattern | null;
    pageNos: number[] | null;
    moduleTypes: string[];
    cols: number;
    history: PatternEntry[];
}

const initState: State = {
    pattern: null,
    pageNos: null,
    moduleTypes: [],
    cols: 1,
    history: []
}

interface ActionProps {
    type: string;
    pattern: EndingPattern;
    pageNos: number[] | null;
    moduleTypes: string[];
    cols: number;
}

export default (state = initState, action: ActionProps): State => {
    switch(action.type) {
        case INIT:
            return initState
        case PATTERN: {
            const entry: PatternEntry = {
                pattern: action.pattern,
                pageNos: action.pageNos,
                moduleTypes: action.moduleTypes,
                cols: action.cols || 1
            }
            return { ...entry, history: [ ...state.history, entry ] }
        }
        default:
            return state
    }
}
